"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var handleSize = function handleSize(size) {
  var sizeObj;

  switch (size) {
    case "small":
      sizeObj = {
        padding: "6px 12px",
        fontSize: "12px"
      };
      return sizeObj;

    case "large":
      sizeObj = {
        padding: "10px 20px",
        fontSize: "18px"
      };
      return sizeObj;

    default:
      sizeObj = {
        padding: "8px 16px",
        fontSize: "16px"
      };
      return sizeObj;
  }
};

var Wrapper = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  /* =========\n  Default Button\n  ========== */\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 500ms ease-in-out;\n  outline: none;\n  justify-content: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  background-color: ", ";\n  padding: ", ";\n  color: ", ";\n  border: ", ";\n  ", "\n\n  /* =========\n  Full Width Button\n  ========== */\n  ", ";\n\n  /* =========\n  With Icon Button\n  ========== */\n  ", ";\n  ", ";\n  ", ";\n\n  /* =========\n  Default Hover Props\n  ========== */\n  &:hover {\n    transition: all 500ms ease-in-out;\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_ref) {
  var alignText = _ref.alignText;
  return alignText;
}, function (_ref2) {
  var fontWeight = _ref2.fontWeight;
  return fontWeight;
}, function (_ref3) {
  var size = _ref3.size;
  var sizeStyling = handleSize(size);
  return sizeStyling.fontSize;
}, function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor;
}, function (_ref5) {
  var size = _ref5.size;
  var sizeStyling = handleSize(size);
  return sizeStyling.padding;
}, function (_ref6) {
  var fontColor = _ref6.fontColor;
  return fontColor;
}, function (_ref7) {
  var borderWidth = _ref7.borderWidth,
      borderColor = _ref7.borderColor;
  return borderWidth === 0 ? "none;" : "".concat(borderWidth, "px solid ").concat(borderColor, ";");
}, function (_ref8) {
  var borderRadius = _ref8.borderRadius;
  return borderRadius !== "unset" && "border-radius: ".concat(borderRadius, ";");
}, function (_ref9) {
  var fullWidth = _ref9.fullWidth;
  return fullWidth && "width: 100%";
}, function (_ref10) {
  var icon = _ref10.icon,
      iconFill = _ref10.iconFill,
      iconFillHover = _ref10.iconFillHover;
  return icon !== "none" && "& svg {\n        width: 20px;\n        height: 20px;\n        fill: ".concat(iconFill, ";\n        transition: all 500ms ease-in-out;\n      }\n      &:hover svg {\n        fill: ").concat(iconFillHover, ";\n      }");
}, function (_ref11) {
  var icon = _ref11.icon,
      iconPosition = _ref11.iconPosition;
  return icon !== "none" && iconPosition === "left" && "& svg {\n        margin-right: 5px;\n      }";
}, function (_ref12) {
  var icon = _ref12.icon,
      iconPosition = _ref12.iconPosition;
  return icon !== "none" && iconPosition === "right" && "& svg {\n        margin-left: 5px;\n      }";
}, function (_ref13) {
  var hoverBackgroundColor = _ref13.hoverBackgroundColor;
  return hoverBackgroundColor;
}, function (_ref14) {
  var hoverFontColor = _ref14.hoverFontColor;
  return hoverFontColor;
});

var _default = Wrapper;
exports.default = _default;